import _ from "underscore";
import templateUrl from 'servicestack/automations/automations-list.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutomationPrompt from "servicestack/automations/automation-prompt";
import TemplateViewPrompt from "servicestack/automations/template-view";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

class AutomationsListController {
  constructor($rootScope) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.$on("$automationSaved", () => $ctrl.query.load(true));
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.query = new AutoQuery({
      url: 'QueryAutomations.json',
      autoLoad: true,
      take: 1000,
      scrollTop: false,
      onLoaded: function (response) {
				response.results.forEach(function (res) {
					res.ingredients = JSON.parse(res.ingredients);
					res.searchText = res.ingredients.map(n => n.word).join(" ");
				});

        $ctrl.automations = response.results;
        $ctrl.allAutomations = response.results;
      }
    });

    $ctrl.recipeTags = [
      {
        title: 'All',
        icon: 'tags'
      },
      {
        title: 'Status Change',
        icon: 'bars'
      },
      {
        title: 'Notifications',
        icon: 'envelope-o'
      },
      {
        title: 'Registration',
        icon: 'user-circle-o'
      },
      {
        title: 'Forms',
        icon: 'pencil-square-o'
      },
      {
        title: 'Shipments',
        icon: 'truck'
      },
      {
        title: 'Shopping',
        icon: 'shopping-cart'
      }
    ];
  }
  filterAutomations(filter) {
    const $ctrl = this;
    if (filter == 'All') {
      return $ctrl.automations = $ctrl.allAutomations;
    }
    $ctrl.automations = $ctrl.allAutomations.filter(f => f.tags.indexOf(filter) >= 0);
  }

  filterAutomationSearch() {
    const $ctrl = this;
    //console.info("hi", $ctrl.automationSearch, $ctrl.allAutomations.filter(f => f.ingredients.indexOf($ctrl.automationSearch) > -1));
    $ctrl.automations = $ctrl.allAutomations.filter(f => f.tags.toLowerCase().includes($ctrl.automationSearch.toLowerCase()) || f.searchText.toLowerCase().includes($ctrl.automationSearch.toLowerCase()) || f.actionType.toLowerCase().includes($ctrl.automationSearch.toLowerCase()) || f.eventType.toLowerCase().includes($ctrl.automationSearch.toLowerCase()));
  }

  edit(automation) {
    const $ctrl = this;
    AutomationPrompt.open({ recipe: automation, automation: automation }).then(() => $ctrl.query.load());
  }
  help(automation) {
    const $ctrl = this;
    TemplateViewPrompt.open({ recipe: automation, automation: automation }).then(() => $ctrl.query.load());
  }
  delete(automation) {
    const $ctrl = this;

    return modals.confirm("Are you sure?", "Delete Automation").result.then(function () {
      $ctrl.bus.send('DeleteAutomation.json', automation).then(function (response) {
        $ctrl.query.load(true);
      });
    });
  }
}

let AutomationsList = {
  bindings: {
  },
  controller: AutomationsListController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default AutomationsList